import {
  Component,
  ViewChild,
  Injector,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {
  StaffsServiceProxy,
  StaffSubordinatesHierarchiesServiceProxy,
  StaffUserLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/public_api';

@Component({
  selector: 'directReportsUserLookupTableModal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './direct-reports-lookup.component.html',
})
export class DirectReportsLookupComponent extends AppComponentBase {
  @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
  @ViewChild('dataTable', { static: true }) dataTable: Table;
  @ViewChild('paginator', { static: true }) paginator: Paginator;

  @Input() ownDetailsEdit: Boolean;

  filterText = '';
  id: number;
  displayName: string;
  public superiorStaffId;

  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
  active = false;
  saving = false;

  selectedSubordinaries = [];

  constructor(
    injector: Injector,
    private _staffsServiceProxy: StaffsServiceProxy,
    private _staffSubordinariesProxy: StaffSubordinatesHierarchiesServiceProxy
  ) {
    super(injector);
  }

  show(): void {
    this.active = true;
    this.paginator.rows = 5;
    this.getAll();
    this.modal.show();
  }

  getAll(event?: LazyLoadEvent) {
    if (!this.active) {
      return;
    }

    if (this.primengTableHelper.shouldResetPaging(event)) {
      this.paginator.changePage(0);
      return;
    }

    this.primengTableHelper.showLoadingIndicator();

    if (this.ownDetailsEdit) {
      this._staffSubordinariesProxy
        .getAllStaffAllowedToBeMySubordinates(
          this.filterText,
          this.primengTableHelper.getSorting(this.dataTable),
          this.primengTableHelper.getSkipCount(this.paginator, event),
          this.primengTableHelper.getMaxResultCount(this.paginator, event)
        )
        .subscribe((result) => {
          this.primengTableHelper.totalRecordsCount = result.totalCount;
          this.primengTableHelper.records = result.items;
          this.primengTableHelper.hideLoadingIndicator();
        });
    } else {
      this._staffSubordinariesProxy
        .getAllStaffAllowedToBeSubordinates(
          this.filterText,
          this.superiorStaffId,
          this.primengTableHelper.getSorting(this.dataTable),
          this.primengTableHelper.getSkipCount(this.paginator, event),
          this.primengTableHelper.getMaxResultCount(this.paginator, event)
        )
        .subscribe((result) => {
          this.primengTableHelper.totalRecordsCount = result.totalCount;
          this.primengTableHelper.records = result.items;
          this.primengTableHelper.hideLoadingIndicator();
        });
    }
  }

  reloadPage(): void {
    this.paginator.changePage(this.paginator.getPage());
  }

  setAndSave(user: StaffUserLookupTableDto) {
    this.id = user.id;
    this.displayName = user.displayName;
    // this.active = false;
    // this.modal.hide();
    this.modalSave.emit(null);
  }

  toggleSubordinary(user: any) {
    if (
      this.selectedSubordinaries?.filter((sub) => sub.staffId === user.staffId)
        .length
    ) {
      this.selectedSubordinaries = this.selectedSubordinaries?.filter(
        (sub) => sub.staffId !== user.staffId
      );
    } else {
      this.selectedSubordinaries.push(user);
    }
  }

  isAlreadySelected(user: any) {
    return (
      this.selectedSubordinaries?.filter((sub) => sub.staffId === user.staffId)
        .length > 0
    );
  }

  close(): void {
    this.active = false;
    this.modal.hide();
    this.modalSave.emit(null);
  }
}
